module.exports = __webpack_public_path__ + "static/AngelaHe8-be83ea8b563a2a08a51359621c7e55f5.webp";